import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OverlayName, OverlaysState } from 'store/overlays/types';

export const initialState: OverlaysState = {
  open: false,
  closeOnOutsideClick: true,
  name: 'none',
  props: {},
};

const { reducer, actions } = createSlice({
  name: 'overlays',
  initialState,
  reducers: {
    resetOverlay() {
      return initialState;
    },
    closeOverlay(state) {
      state.open = false;
    },
    openOverlay(
      state,
      action: PayloadAction<{
        name: OverlayName;
        props?: Record<string, unknown>;
        closeOnOutsideClick?: boolean;
      }>
    ) {
      state.open = true;
      state.name = action.payload.name;
      state.props = action.payload.props || {};
      state.closeOnOutsideClick = action.payload.closeOnOutsideClick ?? false;
    },
  },
});

export const { resetOverlay, closeOverlay, openOverlay } = actions;
export default reducer;
